<template>
  <button
    class="sliderButton"
    :class="[
      `sliderButton--${buttonType}`,
      `sliderButton--${position}`,
      { 'sliderButton--disabled': disabled },
      { 'sliderButton--rightControls': rightControls },
    ]"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: 'SliderButton',
  props: {
    rightControls: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'prev',
    },
    buttonType: {
      type: String,
      default: 'rounded',
    },
  },
};
</script>

<style scoped lang="scss">
.sliderButton {
  $root: &;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &--arrows {
    top: 50%;
    z-index: 3;
    transform: translateY(-50%);
    font-size: 3.6rem;
    transition: opacity $tr, color $tr;

    @include rwd('ultra') {
      width: 4rem;
      height: 4rem;
      font-size: 1.4rem;
      color: $cAddDark02;
      background-color: $cWhite;
      border-radius: 50%;
      box-shadow: 0 3px 7px rgba(23, 25, 51, 0.1);
    }
  }

  &--arrows#{&}--prev {
    left: -5.2rem;

    @include rwd('ultra') {
      left: 8px;
      transform: translate(-50%, -50%);
    }

    &:after {
      @include icomoon('chevron-left');

      @include rwd('ultra') {
        @include icomoon('chevron-left-bold');
      }
    }
  }

  &--arrows#{&}--next {
    right: -5.2rem;

    @include rwd('ultra') {
      right: 8px;
      transform: translate(50%, -50%);
    }

    &:after {
      @include icomoon('chevron-right');

      @include rwd('ultra') {
        @include icomoon('chevron-right-bold');
      }
    }
  }

  &--rounded {
    bottom: 50%;
    width: 4rem;
    height: 4rem;
    font-size: 1.4rem;
    color: $cAddDark02;
    background-color: $cWhite;
    border-radius: 50%;
    box-shadow: 0 3px 7px rgba($cMainDark, 0.1);
    z-index: 3;
    transition: opacity $tr, color $tr;
  }

  &--rounded#{&}--prev {
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%);

    @include rwd('large-phone') {
      left: 8px;
    }

    &:after {
      @include icomoon('chevron-left-bold');
    }
  }

  &--rounded#{&}--next {
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);

    @include rwd('large-phone') {
      right: 8px;
    }

    &:after {
      @include icomoon('chevron-right-bold');
    }
  }

  &--disabled {
    opacity: 0;
    cursor: default;
  }

  &:hover {
    &:not(#{$root}__button--disabled) {
      color: $cSec;
    }
  }

  &--rightControls {
    @include rwd('large-tablet', true) {
      box-shadow: 0 3px 3px rgba($cMainDark, 0.1);

      &--prev {
        right: 3.2rem;
        left: unset;
        transform: translateX(50%);
      }

      &--next {
        right: 3.2rem;
        left: unset;
        transform: translate(50%, calc(-100% - 1.5rem));
      }
    }
  }
}
</style>
